import { render, staticRenderFns } from "./Ads04.vue?vue&type=template&id=a3fff1b8&scoped=true"
import script from "./Ads04.vue?vue&type=script&lang=js"
export * from "./Ads04.vue?vue&type=script&lang=js"
import style0 from "./Ads04.vue?vue&type=style&index=0&id=a3fff1b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fff1b8",
  null
  
)

export default component.exports